import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { useTranslation } from "react-i18next"

const CardObservacionesDocumento = ({
  observaciones,
  setShowObservacionesModal,
  colorSelected,
}: {
  observaciones: string
  setShowObservacionesModal: () => void
  colorSelected: string
}) => {
  const { t } = useTranslation()
  return (
    <div className='tw-flex tw-flex-col'>
      <div
        style={{ backgroundColor: colorSelected }}
        className='tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-h-12 tw-rounded-t-md tw-px-4 tw-text-simple-10'
      >
        {t("crear.facturaRec.remarksLabel")}
        <div
          className='tw-text-simple-10 !tw-bg-transparent !tw-border-none tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-h-10 tw-w-10 tw-rounded'
          onClick={() => setShowObservacionesModal()}
        >
          <FontAwesomeIcon
            icon={["fal", "pen"]}
            className='tw-w-4 tw-h-4 hover:tw-text-secondary'
          />
        </div>
      </div>
      <div className='tw-flex tw-flex-col tw-px-8 tw-py-4 tw-text-left'>
        {observaciones
          .split("\n")
          .map((line: string, index: number, array: string[]) => (
            <React.Fragment key={line}>
              {line}
              {index !== array.length - 1 && <br />}
            </React.Fragment>
          ))}
      </div>
    </div>
  )
}

export default CardObservacionesDocumento
